export default {
  'GET_CLIENT' (state, payload) {
    if(payload.init) {
      state.Clients = payload.payload
    }
    else {
      state.Clients = state.Clients.concat(payload.payload)
    }
  },
  'CHANGE_CLIENTEDIT' (state, payload) {
    for (let key in payload) {
      for (let k in payload[key]) {
        state.SelectedClientEdit[key][k] = payload[key][k]
      }
    }
  },
  'PUSH_CLIENT' (state, payload) {
    state.Clients.push(payload)
  },
  'SET_CLIENTEDIT' (state, payload) {
    localStorage.setItem('client', JSON.stringify(payload))
    state.SelectedClientEdit = payload
  },
  'SET_CLIENTVIEW' (state, payload) {
    state.ClientView = payload
  },
  'PUSH_PEDIDO' (state, payload) {
    state.Pedidos.push(payload)
  },
  'UPDATESTATUS_PEDIDO' (state, payload) {
    state.PedidoView.status = payload.status
  },
  'DELETE_PEDIDO' (state, payload) {
    state.Pedidos = state.Pedidos.filter(p => p.id !== payload)
  },
  'SET_PEDIDOVIEW' (state, payload) {
    state.PedidoView = payload
  },
  'VIEW_PAYMENT_MP' (state, payload) {
    state[payload.comp] = payload.status
  },
  'SET_PEDIDO_ATUAL' (state, payload) {
    state.PedidoAtual = payload
  },
  'SET_TRYAGAINPAY' (state, payload) {
    state.TryAgainPay = payload
  },
  'SET_CUPOM_STORE' (state, payload) {
    state.cupom = payload
  },
  'SET_CLIENTVALIDATE' (state, payload) {
    for(let key in payload) {
      state.ClientValidate[key] = payload[key]
    }
  },
  'SET_EDITCLIENTVALIDATE' (state, payload) {
    for(let key in payload) {
      state.EditClientValidate[key] = payload[key]
    }
  },
  'LOADING_PAY' (state, payload) {
    state.LoadPay = payload
  },
  'SET_VALOR_FRETE' (state, payload) {
    state.ValorFrete = payload
  },
  'SET_NOTASPEDIDO' (state, payload) {
    state.NotasPedido = payload
  },
  'SET_PIX_PAYMENT_STATUS' (state, payload) {
    state.PixApproved = payload
  }
}
